import React from "react";
import "./InfoItem.scss";
const InfoItem = props => {
  const {label, value} = props;
  return (
    <div className="info-item">
      <span> • {label}</span>:{" "}
      <span
        className={`${
          label == "Ghi chú" && value != "Bình thường" ? "red" : ""
        }`}
      >
        {value}
      </span>
    </div>
  );
};
export default InfoItem;
